import React, { type FC } from "react";
import clsx from "clsx";
import { CommonMonthlyPriceLabelKey } from "../../../../../../../common-deprecated/priceUtils";
import PromotionNumbers from "./PromotionNumbers";
import styles from "./CashPrice.module.scss";

type PriceLabelsProps = {
    labels: Array<{ key: string; value: string }>;
    promotions: Array<any>;
    hasPromotions: boolean;
    renderPromotions?: boolean;
};

const PriceLabels: FC<PriceLabelsProps> = ({ labels, promotions, hasPromotions, renderPromotions = true }) => {
    return (
        <span className={clsx(styles.pricewrapper, hasPromotions && styles.flex)}>
            {labels
                .filter(({ key }) => key === CommonMonthlyPriceLabelKey.Price)
                .map(({ key, value }) => (
                    <span key={key} dangerouslySetInnerHTML={{ __html: value }} />
                ))}

            {/* If there is a secondary price, only render the promotions after the secondary price*/}
            {hasPromotions && renderPromotions && <PromotionNumbers promotions={promotions} />}
        </span>
    );
};

export default PriceLabels;
